<!--
  Created 13.11.2023
  Originated from Tailwind UI component: Forms, Toggles, Short toggle
  https://tailwindui.com/components/application-ui/forms/toggles#component-b3e0a15571300f79fced5845f97fa972
-->
<template>
  <Switch
    v-model="enabled"
    class="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:ring-offset-2">
    <span class="sr-only">Use setting</span>
    <span
      aria-hidden="true"
      class="pointer-events-none absolute h-full w-full rounded-md" />
    <span
      aria-hidden="true"
      :class="[enabled ? colorEnabled : colorDisabled, 'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out']" />
    <span
      aria-hidden="true"
      :class="[
        enabled ? 'translate-x-5' : 'translate-x-0',
        'pointer-events-none absolute left-0 inline-block h-5 w-5 rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out'
      ]" />
  </Switch>
</template>

<script setup>
import {
  computed,
} from 'vue';
import { Switch } from '@headlessui/vue';

const props = defineProps({
  enabled: {
    type: Boolean,
    required: true,
    default: false,
  },
  /**
   * The color of the toggle when enabled.
   * This should be a Tailwind CSS background color class.
   */
  colorEnabled: {
    type: String,
    default: 'bg-indigo-600',
  },
  /**
   * The color of the toggle when disabled.
   * This should be a Tailwind CSS background color class.
   */
  colorDisabled: {
    type: String,
    default: 'bg-gray-200',
  },
});

const emit = defineEmits(['update:enabled']);

const enabled = computed({
  get() {
    return props.enabled;
  },
  set() {
    emit('update:enabled', !props.enabled);
  },
});

</script>
